import api from '@/helpers/api'

const API_READ = `/api/pending-point`
const API_RELEASE_SINGLE = `/api/pending-point/`
const API_RELEASE_BULK = `/api/pending-point/release-bulk`

export default {
    namespaced: true,
    state: {
        status: '',
        pendingTransactions: [],
        errMessage: '',
        meta: {
            limit: 10,
            page: 1,
            total: 1
        },
        filter: {},
        search: {},
        sort: {}
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state, { message }) {
            state.status = 'error'
            state.errMessage = message
        },
        read(state, { pendingTransactions }) {
            state.pendingTransactions = [...pendingTransactions]
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = { ...filter }
        },
        set_search(state, { search }) {
            state.search = { ...search }
        },
        clear_search(state) {
            state.search = {}
        },
        set_sort(state, { sort }) {
            state.sort = { ...sort }
        },
        clear_sort(state) {
            state.sort = {}
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1,
            }
        }
    },
    actions: {
        fetchPending({ commit, state }) {
            commit('request')

            const { meta, filter, search, sort } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter, search, sort })
                    .then((result) => {
                        commit('read', { pendingTransactions: result.data.data })
                        commit('switch_page', { meta: { ...result.data.meta } })
                        commit('success')
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        fetchAllPendingIds({ state }) {
            const { filter, search, sort } = state

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}/all-ids`, { filter, search, sort })
                    .then((result) => {
                        return resolve(result.data.data)
                    }).catch((err) => {
                        return reject(err)
                    });
            });
        },
        releaseSingle({ commit }, id) {
            commit('request')

            return new Promise((resolve, reject) => {
                api.request('put', `${API_RELEASE_SINGLE}${id}/release`)
                    .then((result) => {
                        commit('success')
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        releaseBulk({ commit }, transactionIds) {
            commit('request')

            return new Promise((resolve, reject) => {
                api.request('post', API_RELEASE_BULK, {}, { transaction_ids: transactionIds })
                    .then((result) => {
                        commit('success')
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
    },
    getters: {
        pendingTransactions: (state) => state.pendingTransactions,
        isLoading: (state) => state.status === 'loading',
    }
}
